import React from 'react';
import { INotification, ProgressState } from '@Data/notifications/Interfaces';
import NotificationItem from './NotificationItem';
import NotificationProgressIndicator from './NotificationProgressIndicator';

interface ProcessNotificationProps {
    notification: INotification;
    onCancel: (notification: INotification) => void;
    id?: string;
}

interface ProcessNotificationState {
    isCancelToggled: boolean;
}

class ProcessNotificationItem extends React.Component<
    ProcessNotificationProps,
    ProcessNotificationState
> {
    constructor(props) {
        super(props);
        this.state = {
            isCancelToggled: false,
        };
        this.setIsCancelToggled = this.setIsCancelToggled.bind(this);
    }

    setIsCancelToggled(isToggled) {
        this.setState({ isCancelToggled: isToggled });
    }

    render() {
        const innerHtml = (
            <NotificationProgressIndicator
                message={this.props.notification.message}
                progress={
                    this.props.notification.progressInfo.progressPercentage
                }
                remainingTime={
                    this.props.notification.progressInfo.remainingTime
                }
                state={this.props.notification.progressInfo.state}
            />
        );

        let icon, cancelTxt, cancelFn, hideIcon;

        switch (this.props.notification.progressInfo.state) {
            case ProgressState.PENDING:
                // if (!this.state.isCancelToggled) {
                //     icon = <CancelIcon />
                //     cancelFn = () => this.setIsCancelToggled(true);
                //     cancelTxt = "Cancel Process";
                // } else {
                //     icon = <CancelIcon style={{ color: 'red' }} />
                //     cancelFn = () => this.props.onCancel(this.props.notification);
                //     cancelTxt = "Confirm cancellation";
                // }
                hideIcon = true;
                break;
            default:
                cancelFn = () => this.props.onCancel(this.props.notification);
                icon = null;
                cancelTxt = 'Dismiss';
        }

        return (
            <NotificationItem
                message={innerHtml}
                severity={this.props.notification.severity}
                closeText={cancelTxt}
                closeIcon={icon}
                onCancel={cancelFn}
                hideIcon={hideIcon}
                id={this.props.id}
            />
        );
    }
}

export default ProcessNotificationItem;
